// extracted by mini-css-extract-plugin
export var htmlRender = "html-render-module--html-render--rQAIH";